<template>
  <div class="white-container position-relative" style="min-height: 200px;">
    <loader v-if="loader" />

    <h5 class="mb-4">{{ $t('partners.partners_owner') }}</h5>

    <form-fields v-if="ownerParams"
                 :form-columns="12"
                 :prefill-params="ownerParams"
                 :inline="true"
                 :fields="fields"
                 @submit="showConfirmModal = true"
    />

    <b-modal v-model="showConfirmModal"
             :title="$t('partners.partners_owner_confirmation')"
             ok-variant="secondary"
             ok-title="Confirm"
             cancel-variant="outline-secondary"
             @ok="confirmPartnerChange">
      {{ $t('partners.partners_owner_confirm_text') }}
    </b-modal>
  </div>
</template>

<script>
import FormFields from "../../../components/global/formBuilder";
import Modal from "../../global/modal";

export default {
  name: "PartnerOwnerEditForm",
  components: {
    FormFields,
    Modal
  },
  props: {
    partnerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loader: false,
      ownerParams: null,
      fields: [
        {
          label: 'Email',
          placeholder: 'Email',
          required: true,
          type: 'text',
          name: 'email'
        }
      ],
      showConfirmModal: false
    }
  },
  methods: {
    fetchPartnersOwner() {
      this.loader = true;
      this.getData(`partners/${this.partnerId}/owner`)
          .then(({ data }) => {
            if (data.owner) {
              this.ownerParams = {
                email: data.owner.email
              }
            }
          }).finally(() => {
            this.loader = false;
          });
    },
    confirmPartnerChange() {
      this.loader = true;

      this.putData(`partners/${this.partnerId}/owner`, {
          email: this.ownerParams.email
        }).then(({ data }) => {

        }).finally(() => {
          this.loader = false;
        });
    }
  },
  created() {
    this.fetchPartnersOwner();
  }
}
</script>
